
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'


const Basket = (props) => {
    // Popup visibility state
    const [showPopup, setShowPopup] = useState(false); // stays false initially to avoid layout shift until after mount
    const popupRef = useRef(null);

    // Auto-open popup shortly after mount (adjust delay or remove if not needed)
    useEffect(() => {
        const timer = setTimeout(() => setShowPopup(false), 0); // 300ms feels snappier but prevents flash
        return () => clearTimeout(timer);
    }, []);

    // Close on ESC
    useEffect(() => {
        if (!showPopup) return;
        const handleKey = (e) => {
            if (e.key === 'Escape') setShowPopup(false);
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [showPopup]);

    // Focus popup when opened
    useEffect(() => {
        if (showPopup && popupRef.current) {
            popupRef.current.focus();
        }
    }, [showPopup]);

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('popup-overlay')) {
            setShowPopup(false);
        }
    };

    return (
        <div>
            <div className="home-links1">
                <Link to="/" className="home-link navLink">
                    Home
                </Link>
            </div>

            <div className="postdiv">Apple mac book pro</div>
            <div className="email">yannis@brandswap.com</div>
            <div className="extraelem">extraelem</div>

            {/* <button
                type="button"
                className="btn btn-primary"
                onClick={() => setShowPopup(true)}
                style={{ marginTop: '1rem' }}
            >
                Open Test Popup
            </button> */}

            {showPopup && (
                <div
                    className="popup-overlay"
                    onClick={handleOverlayClick}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 0
                    }}
                >
                    <div
                        ref={popupRef}
                        role="dialog"
                        aria-modal="true"
                        tabIndex={-1}
                        className="popup-content"
                        style={{
                            background: '#fff',
                            padding: '1.5rem',
                            borderRadius: '8px',
                            minWidth: '320px',
                            maxWidth: '90%',
                            boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                            position: 'relative'
                        }}
                    >
                        <h2 style={{ marginTop: 0 }}>Test Popup</h2>
                        <p style={{ lineHeight: 1.4 }}>
                            This is a temporary popup to help you test interactions. Replace this content
                            with whatever you need.
                        </p>
                        <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
                            <button
                                type="button"
                                onClick={() => setShowPopup(false)}
                                className="btn btn-secondary"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                onClick={() => alert('Test action fired')}
                                className="btn btn-success"
                            >
                                Test Action
                            </button>
                        </div>
                        <button
                            aria-label="Close popup"
                            onClick={() => setShowPopup(false)}
                            style={{
                                position: 'absolute',
                                top: '0.5rem',
                                right: '0.5rem',
                                background: 'transparent',
                                border: 'none',
                                fontSize: '1.25rem',
                                cursor: 'pointer'
                            }}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Basket
